import styled from "styled-components";

export const Container = styled.div`
  width: ${({ theme }) => (theme.isShopifyApp ? "auto" : "100%")};

  button {
    width: 100%;
  }
`;
